<template>
  <OmtLayoutHeaderFooter :footer="false" :bg="['none', '#F6F6F9']" :header="{ titleLabel: 'Inadimplência' }">
    <OmtLayoutContainer :minHeight="['initial', 'calc(100vh - 80px)']" :alignContent="['', 'flex-start']">
      <OmtRow mb="8px">
        <OmtTypography as="h1-bold" lineHeight="32px"> O pagamento da sua fatura está pendente </OmtTypography>
      </OmtRow>
      <OmtRow flexDirection="column">
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          Olá, <omt-bold>{{ debtData.Nome }}!</omt-bold><br />
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          Não identificamos o pagamento da(s) fatura(s) do seu plano de saúde indicada(s) abaixo:
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px">
          <CBox>
            <CList styleType="disc">
              <CListItem v-for="(fatura, index) in debtData.Faturas" :key="index">
                <omt-bold>Fatura número: {{ fatura.TituloFatura }}</omt-bold
                >, vencimento <omt-bold>{{ fatura.DtVencimento }}</omt-bold
                >, no valor original de <omt-bold>{{ fatura.Valor }}</omt-bold> , e valor atualizado para pagamento
                hoje:
                <omt-bold> {{ fatura.ValorAtualizado }}</omt-bold>
              </CListItem>
            </CList>
          </CBox>
        </OmtTypography>
      </OmtRow>
      <OmtRow>
        <omt-divider />
      </OmtRow>
      <OmtRow flexDirection="column">
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          <omt-bold> Dias em atraso: {{ debtData.DiasEmAtraso }} </omt-bold>
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          <omt-bold> Forma de pagamento cadastrada: </omt-bold> {{ debtData.FormaPagamento }}
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px">
          O pagamento pode ser realizado pelo app do seu banco, em caixas eletrônicos ou agências bancárias mediante a
          apresentação do boleto bancário.
        </OmtTypography>
      </OmtRow>
      <OmtRow>
        <omt-divider />
      </OmtRow>
      <OmtRow flexDirection="column">
        <OmtTypography as="h2-bold" lineHeight="22px" mb="8px">
          <omt-bold> Informações sobre o seu plano </omt-bold>
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          <omt-bold> Registro da operadora na ANS: </omt-bold> Omint Serviços de Saúde S.A. - 35966-1R. Franz Schubert,
          33 - Jardim Paulistano, São Paulo - SP, 01454-020
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          <omt-bold> Nome do plano: </omt-bold> {{ debtData.Plano }}
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          <omt-bold> Nº do contrato na ANS: </omt-bold> {{ debtData.NumeroContrato }}
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          <omt-bold> Beneficiários: </omt-bold> {{ debtData.QuantidadeBeneficiarios }}
        </OmtTypography>
        <CBox>
          <CList styleType="decimal" v-for="(beneficiary, index) in debtData.Beneficiarios" :key="index">
            <CListItem display="flex" flexDirection="column">
              <OmtTypography as="p1" lineHeight="22px">
                <omt-bold>
                  <li>{{ beneficiary.Nome }}</li></omt-bold
                >
              </OmtTypography>
              <OmtTypography as="p1" lineHeight="22px">
                <omt-bold> CPF: </omt-bold> {{ beneficiary.CPF }}
              </OmtTypography>
              <OmtTypography as="p1" lineHeight="22px">
                <omt-bold> Número do título: </omt-bold> {{ beneficiary.Titulo }}
              </OmtTypography>
            </CListItem>
          </CList>
        </CBox>
      </OmtRow>
      <OmtRow>
        <omt-divider />
      </OmtRow>
      <OmtRow mb="16px" flexDirection="column">
        <OmtTypography as="p1" lineHeight="22px" mb="8px">
          Em caso de dúvidas contate nossa central de atendimento pelo número: 0800 726 4000.
        </OmtTypography>
        <OmtTypography as="p1" lineHeight="22px">
          Caso o pagamento já tenha sido realizado, por favor, desconsidere essa mensagem.
        </OmtTypography>
      </OmtRow>
      <OmtRow mb="42px" v-if="debtData.Faturas" class="invoice-cards-row">
        <OmtCard
          class="invoice-card"
          align-items="start"
          p="18px 16px 21px"
          v-for="fatura of debtData.Faturas"
          :key="fatura.Fatura"
        >
          <CFlex mb="24px" align-items="start">
            <OmtIcons name="memo" size="1x" mr="10px" />
            <OmtTypography as="h3-bold"> {{ fatura.DtVencimentoFormatada }} </OmtTypography>
            <OmtIcons name="angle-right" ml="auto" size="1x" />
          </CFlex>
          <CFlex align-items="center">
            <OmtButton
              variant="outline"
              height="40px"
              width="122px"
              py="10px"
              px="39px"
              border="0.5px solid var(--colors-light-secondary-divider)"
              @click="download(fatura.url)"
            >
              <OmtTypography as="h3-semi-bold"> Baixar </OmtTypography>
            </OmtButton>
          </CFlex>
        </OmtCard>
      </OmtRow>

      <FixedButtonRow :useFooter="false">
        <OmtButton :w="['100%', '308px !important']" @click="next()"> Continuar </OmtButton>
      </FixedButtonRow>
    </OmtLayoutContainer>
  </OmtLayoutHeaderFooter>
</template>
<script>
import Header from "@/components/Molecules/Header";
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";

export default {
  name: "notPay",
  components: {
    Header,
    FixedButtonRow
  },
  computed: {
    ...mapState("accessManagement", ["debtData"]),
    ...mapState("saude", ["vinculo"])
  },
  methods: {
    ...mapActions("accessManagement", ["registerDebtNaturalPerson"]),
    async download(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    async next() {
      if (!this.debtData?.Faturas || this.debtData?.Faturas?.length === 0) {
        return;
      }
      this.$root.$emit("show-loading");
      const result = await this.registerDebtNaturalPerson();
      if (result !== "") {
        this.$router.replace("/");
      } else {
        Swal.fire({
          icon: "error",
          text: "Serviço temporariamente indisponível",
          confirmButtonText: "OK"
        });
        this.$root.$emit("hide-loading");
      }
    }
  },
  async mounted() {
    if (!this.debtData?.Faturas) {
      this.$router.replace("/");
    }
    this.$root.$emit("hide-back-button");
    try {
      this.$root.$emit("show-loading");
    } catch (error) {
      console.error("not pay resume load error", error);
    } finally {
      this.loading = false;
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.invoice-cards-row {
  flex-direction: column;
  align-items: stretch;
}

.invoice-card {
  width: 100%;
  margin-bottom: 16px;
}

@media (min-width: 1024px) {
  .invoice-cards-row {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
  }

  .invoice-card {
    flex: 0 0 calc(50% - 16px);
    max-width: calc(50% - 16px);
    margin-right: 16px;
  }
}
</style>
